import { Component, OnInit, Input, SimpleChanges, OnChanges , OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { RequestService } from 'src/app/services/request/request.service';
import Swal from 'sweetalert2';
import { ModalController } from '@ionic/angular';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { Capacitor, Plugins } from '@capacitor/core';
import { SecureOperationFeedbackService } from 'src/app/services/ui/secure-operation-feedback.service';
import { Share } from '@capacitor/share';

const { LocalNotifications } = Plugins;
@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.page.html',
  styleUrls: ['./confirm-email.page.scss'],
})
export class ConfirmEmailPage implements OnInit, OnDestroy {
  private readonly bbvaFinancialEntityId = '0012';
  private readonly bbvaBankCode = '012';
    @Input() selectedBankId: any;
      @Input() receiverRfc: any;
  @Input() receiverName: string;
  @Input() amount: any;
  @Input() currency: any;
  @Input() destination: any;
  @Input() email: any;
  @Input() confirmationChannel: 'email' | 'whatsapp' | 'sms' = 'email';
  @Input() concepto: any;
  @Input() alias: any;
  @Input() saveAccount = false;
  @Input() fee: number = 10;
  @Input() holderName: any;
  @Input() bankName: any;
  @Input() profile_id: any;
  @Input() metodo: any;
  @Input() paymentEndpoint: string;
  @Input() paymentIdentifier: string;
  public token: string;
  remainingTime: number;
  private countdownInterval: any;
  public rechargeMethod: string = "COINPAYMENT";
  public isTransferLoading: boolean = false;
  @Input() dest_tag: any;
//CONFIRMACIÓN DE CORREO DE RETIROS
@Input() address: any;
@Input() currency2: any;

//CONFIRMACIÓN DE CORREO DE RETIROS
//CONFIRMACIÓN DE CORREO DE RETIROS
  confirmForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private request: RequestService,
    private modalcontroller: ModalController,
    private walletService: WalletServiceService,
    private secureFeedback: SecureOperationFeedbackService,
  ) { }

  ngOnInit() {
    this.startCountdown();
console.log('met_', this.rechargeMethod);
console.log('met__', this.metodo);

    
  }
 
  ngOnDestroy() {
    this.stopCountdown();
  }

  startCountdown() {
    this.remainingTime = 120; //299= 4 minutes and 59 seconds

    this.countdownInterval = setInterval(() => {
      this.remainingTime--;

      if (this.remainingTime <= 0) {
        // Stop the countdown when the remaining time reaches zero or below
        this.stopCountdown();
        // Perform any necessary actions when the countdown completes
        // For example, show a message to the user indicating the timeout
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.countdownInterval);
  }
  formatTime(time: number): string {
    const minutes = Math.floor(time / 60).toString().padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
  updateToken(event: any) {
    this.token = event.target.value;
  }

  Retirar(){
    if (this.isTransferLoading) {
      return;
    }

    if(this.metodo==='FIAT' || this.metodo==='CIE' || this.metodo==='VISA' || this.metodo==='BBVA' || this.metodo==='SPEI' || this.metodo==='OPENPAY'){
      this.confirmEmailFIAT();
    }else if (this.metodo==='COINPAYMENT'){
      this.newPaymentCRIPTO();
    }
    
  }

  confirmEmailFIAT() {
    console.log('tok', this.token);
    console.log('profile_id', this.profile_id);
    console.log('amount', this.amount);
    console.log('currency', this.currency);
    console.log('destination', this.destination);
  
    if (!this.token) {
      this.secureFeedback.fail('Ingresa el código de seguridad');
      return;
    }

    this.secureFeedback.begin('Generando código dinámico');
    this.setTransferLoading(true);

    if (this.metodo === 'FIAT') {
      this.stripe_payout({
        amount: this.amount,
        destination: this.destination,
        id: this.profile_id,
        token: this.token,
      });
      return;
    }

    if (this.metodo === 'OPENPAY' && this.paymentEndpoint === 'openpay-payouts') {
      this.openpayPayout({
        amount: this.amount,
        clabe: this.destination,
        holder_name: this.holderName,
        description: this.concepto,
        alias: this.alias,
        token: this.token,
      });
      return;
    }

    if (
      (this.metodo === 'VISA' || this.metodo === 'BBVA' || this.metodo === 'SPEI') &&
      this.paymentEndpoint === 'make_a_bbva_api_channel_business_payment'
    ) {
      const internalTransfer = this.metodo === 'BBVA';
      const bbvaChannelPayload = {
        selectedBankId: this.selectedBankId,
        receiverRfc: this.receiverRfc,
        receiverName: this.receiverName?.trim(),
        amount: this.amount,
        fee: this.fee,
        destination: this.destination,
        id: this.profile_id,
        identifier: this.paymentIdentifier,
        concepto: this.concepto,
        alias: this.alias,
        bankName: this.getBankDisplayName(),
        destinationLabel: this.getDestinationLabel(),
        receipt_email: this.email,
        internal_transfer: internalTransfer,
        spei_transfer: !internalTransfer,
        save_account: this.saveAccount === true,
        token: this.token,
      };

      this.bbvaChannelBusinessPayment(bbvaChannelPayload);
      return;
    }

    // Preserve the legacy non-BBVA SPEI path while also letting its financial
    // endpoint validate the same token when that integration is selected.
    if (this.metodo === 'SPEI') {
      this.createWireTransfer({
        spei_transfer: true,
        amount: this.amount,
        directionNumber: this.destination,
        id: this.profile_id,
        token: this.token,
      });
      return;
    }

    this.secureFeedback.fail('Método de retiro no compatible');
    this.setTransferLoading(false);
  }
  setTransferLoading(isLoading: boolean) {
    this.isTransferLoading = isLoading;
  }

  async openpayPayout(payoutData: any) {
    try {
      const response = await this.request.createRequestPost('openpay-payouts', payoutData);
      const payoutResponse = this.parseApiResponse(response);

      if (payoutResponse?.success !== true) {
        throw payoutResponse;
      }

      this.secureFeedback.succeed('Retiro Openpay autorizado');
      this.sendPayoutNotification('Openpay');
      this.setTransferLoading(false);
      await this.dismissTwoModals();

      Swal.fire({
        title: 'Retiro Openpay creado',
        text: payoutResponse?.message || 'La solicitud de retiro bancario fue aceptada por Openpay.',
        icon: 'success',
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
      });
    } catch (error: any) {
      const payload = error?.error ?? error;
      this.secureFeedback.fail('No se pudo procesar el retiro Openpay');
      this.setTransferLoading(false);

      Swal.fire({
        title: 'Retiro no procesado',
        text: this.getBbvaResponseMessage(payload) || 'Openpay no pudo aceptar la solicitud.',
        icon: 'error',
        confirmButtonText: 'Entendido',
        color: '#ffffff',
        background: '#010f4e',
      });
    }
  }
  dismiss(){
    if (this.isTransferLoading) {
      return;
    }
    this.modalcontroller.dismiss()
  }

  createWireTransfer(payoutData){
    this.request.createRequestPost('createWireTransfer', payoutData)
    .then(response => {
      console.log('Payout response', response);
      let payoutResponseData;
		  if (Capacitor.getPlatform() !== 'web') {
       payoutResponseData = JSON.parse(response);
      console.log('Payout response code', payoutResponseData.code);
      }else{
        payoutResponseData = response;
      }
      if (payoutResponseData.code === 201) {
        this.secureFeedback.succeed('Transferencia autorizada');
        console.log('Fund transfer was successful');
        this.setTransferLoading(false);
        Swal.fire({
          title: 'Transferencia procesada con Success',
          text: `Transferencia enviada de la cuenta de tu correo ${this.email}, por monto de $${this.amount}${this.currency}`,
          icon: 'success',

          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
        }).then(() => {
          console.log("Alert displayed successfully.");
        }).catch((error) => {
          console.error("Error displaying alert:", error);
        });
        this.dismiss();
      } else {
        this.secureFeedback.fail('Transferencia no autorizada');
        this.setTransferLoading(false);
        console.log('Fund transfer failed');
        // Handle failure here (e.g., show an error message to the user)
      }
    })
    .catch((error) => {
      this.secureFeedback.fail('No se pudo procesar la transferencia');
      this.setTransferLoading(false);
      console.error('Payout request error', error);
      // Handle network errors or other unexpected errors here
    });
  }

  async bbvaChannelBusinessPayment(payoutData: any) {
  if (!this.validateBbvaChannelDestination(payoutData)) {
    this.setTransferLoading(false);
    return;
  }


  this.request.createRequestPost('make_a_bbva_api_channel_business_payment', payoutData)
    .then(async (response: any) => {
      console.log('Payout response', response);

      let payoutResponseData: any;

      if (Capacitor.getPlatform() !== 'web') {
        payoutResponseData = typeof response === 'string' ? JSON.parse(response) : response;
      } else {
        payoutResponseData = response;
      }

      console.log('Parsed payout response', payoutResponseData);

      if (
        payoutResponseData?.success === true &&
        payoutResponseData?.status >= 200 &&
        payoutResponseData?.status < 300
      ) {
        this.secureFeedback.succeed(`${this.getPayoutMethodLabel()} autorizado`);
        const transferData = payoutResponseData?.data || {};

        if (Number(payoutResponseData.status) === 200) {
          this.sendPayoutNotification(this.getPayoutMethodLabel());
        }

        this.setTransferLoading(false);
        await this.dismissTwoModals();

        void this.showBbvaTransferReceipt(transferData).catch((error) => {
          console.error('No se pudo mostrar el comprobante de la transferencia autorizada.', error);
        });
        return;
      }

      this.setTransferLoading(false);
      this.secureFeedback.fail('Transferencia no autorizada');
      await this.dismissTwoModals();
      Swal.fire({
        toast: true,
        position: 'top-end',
        width: 'min(440px, calc(100vw - 24px))',
        padding: '14px 16px',
        showConfirmButton: false,
        showCloseButton: true,
        timer: 14000,
        timerProgressBar: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        backdrop: false,
        icon: payoutResponseData?.status >= 500 ? 'error' : 'warning',
        title: 'No se pudo procesar la transferencia',
        text: this.getBbvaResponseMessage(payoutResponseData)
          || 'La respuesta no regreso en el formato esperado.',
        color: '#ffffff',
        background: '#010f4e',
        customClass: {
          container: 'bbva-transfer-toast-container',
          popup: 'bbva-success-banner bbva-success-toast'
        },
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });
    })
    .catch(async (error: any) => {
      this.secureFeedback.fail('No se pudo procesar la transferencia');
      this.setTransferLoading(false);
      console.error('Payout request error', error);
      const errorPayload = error?.error ?? error;

      await this.dismissTwoModals();
      Swal.fire({
        toast: true,
        position: 'top-end',
        width: 'min(440px, calc(100vw - 24px))',
        padding: '14px 16px',
        showConfirmButton: false,
        showCloseButton: true,
        timer: 14000,
        timerProgressBar: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        backdrop: false,
        icon: 'error',
        title: 'Error al procesar la transferencia',
        text: this.getBbvaResponseMessage(errorPayload)
          || 'Ocurrio un problema al enviar la solicitud. Intentalo nuevamente.',
        color: '#ffffff',
        background: '#010f4e',
        customClass: {
          container: 'bbva-transfer-toast-container',
          popup: 'bbva-success-banner bbva-success-toast'
        },
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });
    });
	}
	
  private async showBbvaTransferReceipt(transferData: any): Promise<void> {
    const amount = Number(this.amount);
    const formattedAmount = Number.isFinite(amount)
      ? new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
      : String(this.amount || '0.00');
    const fee = Number(this.fee);
    const formattedFee = Number.isFinite(fee)
      ? new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(fee)
      : '0.00';
    const beneficiary = String(this.receiverName || transferData?.receiver?.informationReceiver?.name || '').trim();
    const reference = String(transferData?.sequenceReference || 'No disponible');
    const folio = String(transferData?.id || transferData?.movementNumber || 'No disponible');
    const operationDate = String(transferData?.executionDate || transferData?.accountingDate || transferData?.applicationDate || 'No disponible');
    const originNumber = String(transferData?.sender?.numberAccount || '').replace(/\D/g, '');
    const origin = originNumber ? `Cuenta ·${originNumber.slice(-4)}` : 'Cuenta de origen';
    const concept = String(this.concepto || 'Laniakea Pay');
    const destination = this.getMaskedDestination();
    const bankName = this.getBankDisplayName();
    const safe = (value: unknown) => this.escapeHtml(String(value ?? ''));
    const row = (label: string, value: string, extraClass = '') => `
      <div class="bbva-receipt-row ${extraClass}">
        <dt>${safe(label)}</dt><dd>${safe(value)}</dd>
      </div>`;
    const shareText = [
      'Transferencia procesada con éxito',
      `Monto: $${formattedAmount} ${this.currency || 'MXN'}`,
      `Beneficiario: ${beneficiary}`,
      `Destino: ${destination}`,
      `Referencia: ${reference}`,
      `Folio: ${folio}`,
      `Fecha: ${operationDate}`,
    ].join('\n');

    await Swal.fire({
      toast: false,
      position: 'center',
      width: 'min(560px, calc(100vw - 24px))',
      padding: 0,
      background: '#fff',
      showConfirmButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      heightAuto: false,
      customClass: {
        container: 'bbva-receipt-container',
        popup: 'bbva-receipt-popup',
        htmlContainer: 'bbva-receipt-html',
      },
      html: `
        <article class="bbva-receipt">
          <header class="bbva-receipt-header">
            <span>Comprobante Hubble</span>
            <button type="button" class="bbva-receipt-close" aria-label="Cerrar comprobante"><span aria-hidden="true">×</span><small>Cerrar</small></button>
          </header>
          <section class="bbva-receipt-hero">
            <div class="bbva-receipt-check" aria-hidden="true">✓</div>
            <h1>Transferencia<br>exitosa</h1>
            <p>Monto transferido</p>
            <strong>$${safe(formattedAmount)}</strong>
            <small>${safe(this.currency || 'MXN')}</small>
          </section>
          <dl class="bbva-receipt-details">
            ${row('Origen', origin)}
            <div class="bbva-receipt-row bbva-receipt-destination">
              <dt>Destino</dt>
              <dd><strong>${safe(beneficiary)}</strong><span>${safe(destination)}</span><small>${safe(this.getDestinationLabel())} · ${safe(bankName)}</small></dd>
            </div>
            ${row('Comisión', `$${formattedFee} ${this.currency || 'MXN'}`)}
            ${row('Concepto', concept)}
            ${row('Tipo de operación', this.metodo === 'BBVA' ? 'Transferencia a cuenta BBVA' : 'Transferencia interbancaria')}
            ${row('Referencia', reference)}
            ${row('Folio de operación', folio)}
            ${row('Fecha de operación', operationDate)}
            ${this.receiverRfc ? row('RFC beneficiario', String(this.receiverRfc)) : ''}
            ${this.saveAccount && this.alias ? row('Alias guardado', String(this.alias)) : ''}
            ${this.email ? row('Comprobante por correo', String(this.email)) : ''}
          </dl>
          <footer class="bbva-receipt-footer">
            <button type="button" class="bbva-receipt-share" aria-label="Compartir comprobante">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="5" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8 11 7-5M8 13l7 5"/></svg>
              <span>Compartir</span>
            </button>
          </footer>
        </article>`,
      didOpen: (popup) => {
        popup.querySelector('.bbva-receipt-close')?.addEventListener('click', () => Swal.close());
        popup.querySelector('.bbva-receipt-share')?.addEventListener('click', async () => {
          try {
            if (Capacitor.getPlatform() === 'web' && !navigator.share && navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(shareText);
            } else {
              await Share.share({ title: 'Comprobante de transferencia', text: shareText });
            }
          } catch (error) {
            console.error('No se pudo compartir el comprobante.', error);
          }
        });
      },
    });
  }


	private validateBbvaChannelDestination(payoutData: any): boolean {
	  if (this.paymentEndpoint !== 'make_a_bbva_api_channel_business_payment') {
	    return true;
	  }

	  const destination = String(payoutData?.destination ?? this.destination ?? '').replace(/\D/g, '');
	  const isCardPayment = this.metodo === 'VISA';
	  const isClabePayment = this.metodo === 'SPEI';
	  const selectedBankId = String(payoutData?.selectedBankId ?? this.selectedBankId ?? '');
	  const isBbvaDestination = selectedBankId === this.bbvaFinancialEntityId ||
	    (isClabePayment && destination.startsWith(this.bbvaBankCode));

	  if (this.metodo === 'BBVA' && destination.length !== 10) {
	    Swal.fire({
	      title: 'Cuenta BBVA inválida',
	      text: 'Las transferencias a cuentas BBVA solo se permiten con número de cuenta de 10 dígitos.',
	      icon: 'error',
	      confirmButtonText: 'OK',
	      color: '#ffffff',
	      background: '#010f4e',
	    });
	    return false;
	  }

	  if ((isCardPayment || isClabePayment) && isBbvaDestination) {
	    Swal.fire({
	      title: 'Destino BBVA no permitido',
	      text: 'Para cuentas BBVA usa la opción BBVA con número de cuenta de 10 dígitos. Las transferencias por tarjeta o CLABE solo pueden enviarse a bancos de terceros.',
	      icon: 'error',
	      confirmButtonText: 'OK',
	      color: '#ffffff',
	      background: '#010f4e',
	    });
	    return false;
	  }

	  return true;
	}

	private getBbvaResponseMessage(payload: any): string {
	  if (!payload) {
	    return '';
  }

  const candidates = [
    payload?.message,
    payload?.error,
    payload?.title,
    payload?.data?.message,
    payload?.data?.messages?.[0]?.message,
    payload?.data?.messages?.[0]?.description,
    payload?.data?.messages?.[0]?.text,
    payload?.data?.error,
    payload?.raw
  ];

  const directMessage = candidates.find((value) => typeof value === 'string' && value.trim().length > 0);
  if (directMessage) {
    return directMessage.trim();
  }

  if (Array.isArray(payload?.data?.messages) && payload.data.messages.length > 0) {
    return payload.data.messages
      .map((item: any) => item?.message || item?.description || item?.text || item?.code)
      .filter((value: any) => typeof value === 'string' && value.trim().length > 0)
      .join(' | ');
  }

  return '';
}

private escapeHtml(value: string): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

getDestinationLabel(): string {
  if (this.metodo === 'OPENPAY') {
    return 'CLABE Openpay';
  }
  if (this.metodo === 'BBVA') {
    return 'Cuenta BBVA';
  }

  if (this.metodo === 'SPEI') {
    return 'CLABE interbancaria';
  }

  if (this.metodo === 'VISA') {
    return 'Tarjeta';
  }

  if (this.metodo === 'FIAT') {
    return 'Cuenta Stripe';
  }

  return this.metodo || 'Destino';
}

getBankDisplayName(): string {
  if (this.bankName) {
    return this.bankName;
  }

  if (this.metodo === 'BBVA') {
    return 'BBVA MEXICO';
  }

  if (this.selectedBankId) {
    return this.selectedBankId;
  }

  return 'N/A';
}

getMaskedDestination(): string {
  const cleanDestination = String(this.destination ?? '').replace(/\D/g, '');

  if (!cleanDestination) {
    return 'N/A';
  }

  if (cleanDestination.length <= 4) {
    return cleanDestination;
  }

  return `${'*'.repeat(Math.max(cleanDestination.length - 4, 0))}${cleanDestination.slice(-4)}`;
}

hasTransferSummary(): boolean {
  return !!(this.amount || this.currency || this.destination || this.concepto || this.alias || this.bankName || this.receiverRfc);
}

async dismissTwoModals() {
  try {
    for (let i = 0; i < 2; i++) {
      const topModal = await this.modalcontroller.getTop();
      if (topModal) {
        await topModal.dismiss();
      }
    }
  } catch (error) {
    console.error('Error dismissing modals', error);
  }
}
stripe_payout(payoutData){
  this.request.createRequestPost('Payout', payoutData)
  .then(response => {
    console.log('Payout response', response);
    const payoutResponseData = JSON.parse(response);
    console.log('Payout response code', payoutResponseData.code);

    if (payoutResponseData.code === 200) {
      this.secureFeedback.succeed('Retiro a tarjeta autorizado');
      console.log('Fund transfer was successful');
      this.sendPayoutNotification('tarjeta');
      this.setTransferLoading(false);
      Swal.fire({
        title: 'Transferencia procesada con Success',
        text: `Transferencia enviada de la cuenta de tu correo ${this.email}, por monto de $${this.amount}${this.currency}`,
        icon: 'success',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      }).then(() => {
        console.log("Alert displayed successfully.");
      }).catch((error) => {
        console.error("Error displaying alert:", error);
      });
      this.dismiss();
    } else {
      this.secureFeedback.fail('Retiro a tarjeta no autorizado');
      this.setTransferLoading(false);
      console.log('Fund transfer failed');
      // Handle failure here (e.g., show an error message to the user)
    }
  })
  .catch((error) => {
    this.secureFeedback.fail('No se pudo procesar el retiro');
    this.setTransferLoading(false);
    console.error('Payout request error', error);
    // Handle network errors or other unexpected errors here
  });
}
  newPaymentCRIPTO() {
    if (this.token) {
      this.secureFeedback.begin('Generando código dinámico');
      this.setTransferLoading(true);
      const deposit = {
        profile_id: this.profile_id,
        type: "WITHDRAW",
        qty: this.amount,
        address: this.address,
        currency2: this.currency2,
        method: this.rechargeMethod,
        currency: this.currency,
        dest_tag: this.dest_tag,
        token: this.token,
      };

      this.walletService.newWithDrawal(deposit).then((data) => {
        const withdrawalResponse = this.parseApiResponse(data);

        if (!this.hasStatus200(withdrawalResponse)) {
          throw withdrawalResponse;
        }

        this.secureFeedback.succeed('Retiro CoinPayments autorizado');
        this.sendPayoutNotification('CoinPayments');
        this.setTransferLoading(false);
        this.dismiss();

        Swal.fire({
          title: 'Success',
          text: 'Transfer successful',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      }).catch((error) => {
        this.setTransferLoading(false);
        this.secureFeedback.fail('Código incorrecto o retiro no procesado');
        console.error('CoinPayments payout request error', error);
      });
    }
  }

  private sendPayoutNotification(method: string): void {
    const formattedAmount = this.amount != null ? `${this.amount} ${this.currency || ''}`.trim() : '';
    const notification = {
      title: `Retiro ${method} procesado`,
      body: formattedAmount
        ? `Tu retiro por ${formattedAmount} fue procesado correctamente.`
        : 'Tu retiro fue procesado correctamente.',
      profile_id: this.profile_id,
      // Email, WhatsApp, the in-app record and push are independent delivery
      // channels. A stale FCM token must not make a completed payout look bad.
      delivery_mode: 'best_effort',
    };

    if (Capacitor.getPlatform() !== 'web') {
      const notificationTime = new Date(Date.now() + 250);
      const notificationId = Math.floor(Date.now() % 2147483647);

      Promise.resolve(LocalNotifications.schedule({
        notifications: [{
          title: notification.title,
          body: notification.body,
          id: notificationId,
          schedule: { at: notificationTime },
          sound: null,
          attachments: null,
          actionTypeId: '',
          extra: {
            profile_id: this.profile_id,
            payout_method: method,
          },
          channelId: null,
        }],
      })).catch((error) => {
        console.error('Failed to schedule native payout notification:', error);
      });
    }

    this.request.createRequestPost('GreatAtractorNotifications', notification)
      .catch((error) => {
        // A notification failure must never change the result of a completed payout.
        console.error('Failed to send payout notification:', error);
      });
  }

  private getPayoutMethodLabel(): string {
    if (this.metodo === 'BBVA') {
      return 'BBVA';
    }

    if (this.metodo === 'VISA') {
      return 'a tarjeta';
    }

    return 'SPEI';
  }

  private parseApiResponse(response: any): any {
    if (typeof response !== 'string') {
      return response;
    }

    try {
      return JSON.parse(response);
    } catch {
      return response;
    }
  }

  private hasStatus200(response: any): boolean {
    return Number(response?.status ?? response?.code ?? response?.statusCode) === 200;
  }
}  
